import AvailableShifts from "./AvailableShifts";
import EmployeeAttendance from "./EmployeeAttendance";
import EventsStatistics from "./EventsStatistics";
import ForecastingChart from "./ForecastingChart";
import ShiftCoverage from "./ShiftCoverage";

function Widgets({ approve, deny }: any) {
    return (
        <div className="tw-p-1">
            <EventsStatistics />
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 tw-mb-3 tw-items-stretch">
                <div className="lg:tw-col-span-2 tw-h-full">
                    <ForecastingChart />
                </div>

                <div className="lg:tw-col-span-1 tw-h-full">
                    <AvailableShifts approve={approve} deny={deny} />
                </div>
            </div>
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 tw-h-full">
                <div className="lg:tw-col-span-2">
                    <ShiftCoverage />
                </div>
                 <div className="lg:tw-col-span-1">
                    <EmployeeAttendance />
                </div>
            </div>
        </div>
    );
}

export default Widgets;
